import { render } from "./App.vue?vue&type=template&id=5a9de368"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5a9de368&lang=css"

import exportComponent from "C:\\sw\\ar-unity-renderer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__